import angular from 'angular';
import ChunkFilterFactory from './chunk.filter';
import RemoveSalutationFilterFactory from './remove-salutation.filter';
import TitleCaseFilterFactory from './title-case.filter';

const injectorName = 'ws.common.filters';
export default injectorName;

angular.module(injectorName, [])
  .filter('chunk', ChunkFilterFactory)
  .filter('removeSalutation', RemoveSalutationFilterFactory)
  .filter('titleCase', TitleCaseFilterFactory);



// WEBPACK FOOTER //
// ./src/filters/index.js